import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInteractions = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 19 16",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "m14.882 12.468-.573.25a.625.625 0 0 1 .243-.78l.33.53Zm.938 2.145.573-.25-.573.25Zm-.336.326-.269.564.269-.564Zm-3.2-1.524-.096-.618c.124-.02.25 0 .364.053l-.269.565ZM5.504 8.329c0 2.406 2.403 4.548 5.626 4.548v1.25c-3.682 0-6.876-2.49-6.876-5.798h1.25Zm5.626-4.548c-3.223 0-5.626 2.141-5.626 4.548h-1.25c0-3.308 3.194-5.798 6.876-5.798v1.25Zm5.626 4.548c0-2.407-2.403-4.548-5.626-4.548V2.53c3.682 0 6.876 2.49 6.876 5.798h-1.25Zm-2.205 3.608c1.373-.854 2.205-2.173 2.205-3.608h1.25c0 1.95-1.132 3.636-2.795 4.67l-.66-1.062Zm.696 2.926-.939-2.145 1.146-.5.938 2.144-1.145.501Zm.505-.489a.375.375 0 0 0-.505.49l1.145-.502c.325.742-.447 1.49-1.178 1.14l.537-1.128Zm-3.2-1.524 3.2 1.524-.538 1.129-3.2-1.524.537-1.129Zm-1.422.027c.362 0 .715-.027 1.057-.08l.19 1.235a8.191 8.191 0 0 1-1.247.095v-1.25Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.251 11.347c3.453 0 6.251-2.316 6.251-5.174C13.502 3.316 10.704 1 7.252 1 3.798 1 1 3.316 1 6.173c0 1.693.982 3.196 2.5 4.14l-.938 2.144a.25.25 0 0 0 .337.326l3.2-1.524a7.56 7.56 0 0 0 1.152.088Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m3.5 10.312.573.25a.625.625 0 0 0-.243-.78l-.33.53Zm-.938 2.145-.573-.25.573.25Zm.337.326-.27-.564.27.564Zm3.2-1.524.095-.618a.624.624 0 0 0-.364.054l.269.564Zm6.778-5.086c0 2.407-2.403 4.549-5.626 4.549v1.25c3.682 0 6.876-2.49 6.876-5.799h-1.25ZM7.251 1.625c3.223 0 5.626 2.142 5.626 4.548h1.25c0-3.307-3.194-5.798-6.876-5.798v1.25ZM1.625 6.173c0-2.406 2.403-4.548 5.626-4.548V.375C3.57.375.375 2.865.375 6.173h1.25ZM3.83 9.782c-1.373-.854-2.205-2.174-2.205-3.609H.375c0 1.95 1.132 3.636 2.795 4.67l.66-1.061Zm-.695 2.926.938-2.145-1.145-.501-.939 2.145 1.146.5Zm-.505-.49c.313-.149.644.172.505.49l-1.146-.501c-.324.742.447 1.489 1.178 1.14L2.63 12.22Zm3.2-1.523-3.2 1.524.537 1.128 3.2-1.524-.537-1.128Zm1.421.027c-.362 0-.715-.028-1.057-.08l-.19 1.235a8.18 8.18 0 0 0 1.247.095v-1.25Z",
			fill: "#454545"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.449 5.096h5.82M4.449 7.467h5.82",
			stroke: "#fff",
			strokeWidth: 1.25,
			strokeLinecap: "round"
		})
	]
});
export default SvgInteractions;
